var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: {
                title: _vm.$t("home.vgmTitle"),
                isShowFollow: false,
                isShowFull: false,
              },
              on: { open: _vm.handleLoadBkVgmContainers },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c("div", { staticClass: "filter-container-content" }, [
              _c("div", { staticClass: "filter-container-content" }, [
                _c(
                  "div",
                  { staticClass: "table-container-new-back" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "form",
                        attrs: {
                          rules: _vm.rules,
                          "label-position": "top",
                          model: _vm.form,
                        },
                      },
                      [
                        _c(
                          "el-table",
                          {
                            ref: "multipleTable",
                            attrs: { data: _vm.form.formVgm },
                          },
                          [
                            _c(
                              "el-table-column",
                              {
                                attrs: { prop: "vesselCode", width: "100" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "formVgm." +
                                                scope.$index +
                                                ".vesselCode",
                                              rules: _vm.rules.vesselCode,
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase",
                                                },
                                              ],
                                              attrs: {
                                                disabled: _vm.preLockFlag,
                                                maxlength: "50",
                                                onblur:
                                                  "this.value = this.value.toUpperCase()",
                                              },
                                              model: {
                                                value: scope.row.vesselCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "vesselCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.vesselCode",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "span",
                                    { staticClass: "required-marker" },
                                    [_vm._v(" *")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "required-marker" },
                                    [_vm._v(_vm._s(_vm.$t("home.vesselCode")))]
                                  ),
                                ]),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              {
                                attrs: { prop: "voyageNo", width: "100" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "formVgm." +
                                                scope.$index +
                                                ".voyageNo",
                                              rules: _vm.rules.voyageNo,
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase",
                                                },
                                              ],
                                              attrs: {
                                                disabled: _vm.preLockFlag,
                                                maxlength: "50",
                                                onblur:
                                                  "this.value = this.value.toUpperCase()",
                                              },
                                              model: {
                                                value: scope.row.voyageNo,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "voyageNo",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.voyageNo",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "span",
                                    { staticClass: "required-marker" },
                                    [_vm._v(" *")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "required-marker" },
                                    [_vm._v(_vm._s(_vm.$t("home.voyageNo")))]
                                  ),
                                ]),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              {
                                attrs: { prop: "voyageLeg", width: "100" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "formVgm." +
                                                scope.$index +
                                                ".voyageLeg",
                                              rules: _vm.rules.voyageLeg,
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase",
                                                },
                                              ],
                                              attrs: {
                                                disabled: _vm.preLockFlag,
                                                maxlength: "50",
                                                onblur:
                                                  "this.value = this.value.toUpperCase()",
                                              },
                                              model: {
                                                value: scope.row.voyageLeg,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "voyageLeg",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.voyageLeg",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "span",
                                    { staticClass: "required-marker" },
                                    [_vm._v(" *")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "required-marker" },
                                    [_vm._v(_vm._s(_vm.$t("home.voyageLeg")))]
                                  ),
                                ]),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              {
                                attrs: { prop: "bkNo", width: "200" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "formVgm." +
                                                scope.$index +
                                                ".bkNo",
                                              rules: _vm.rules.bkNo,
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase",
                                                },
                                              ],
                                              attrs: {
                                                disabled: _vm.preLockFlag,
                                                title: scope.row.bkNo,
                                                maxlength: "50",
                                                onblur:
                                                  "this.value = this.value.toUpperCase()",
                                              },
                                              model: {
                                                value: scope.row.bkNo,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "bkNo",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.bkNo",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "span",
                                    { staticClass: "required-marker" },
                                    [_vm._v(" *")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "required-marker" },
                                    [_vm._v(_vm._s(_vm.$t("home.bkNo")))]
                                  ),
                                ]),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              {
                                attrs: { prop: "blNo", width: "200" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "formVgm." +
                                                scope.$index +
                                                ".blNo",
                                              rules: _vm.rules.blNo,
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase",
                                                },
                                              ],
                                              attrs: {
                                                disabled: _vm.preLockFlag,
                                                title: scope.row.blNo,
                                                maxlength: "50",
                                                onblur:
                                                  "this.value = this.value.toUpperCase()",
                                              },
                                              model: {
                                                value: scope.row.blNo,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "blNo",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.blNo",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "span",
                                    { staticClass: "required-marker" },
                                    [_vm._v(" *")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "required-marker" },
                                    [_vm._v(_vm._s(_vm.$t("home.blNo")))]
                                  ),
                                ]),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              {
                                attrs: { prop: "containerNo", width: "180" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "formVgm." +
                                                scope.$index +
                                                ".containerNo",
                                              rules: _vm.rules.containerNo,
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase",
                                                },
                                              ],
                                              attrs: {
                                                disabled: _vm.preLockFlag,
                                                maxlength: "11",
                                                onblur:
                                                  "this.value = this.value.toUpperCase()",
                                              },
                                              model: {
                                                value: scope.row.containerNo,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "containerNo",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.containerNo",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "span",
                                    { staticClass: "required-marker" },
                                    [_vm._v(" *")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "required-marker" },
                                    [_vm._v(_vm._s(_vm.$t("home.containerNo")))]
                                  ),
                                ]),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              {
                                attrs: { prop: "containerType", width: "140" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "formVgm." +
                                                scope.$index +
                                                ".containerType",
                                              rules: _vm.rules.containerType,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  clearable: "",
                                                  disabled: _vm.preLockFlag,
                                                },
                                                model: {
                                                  value:
                                                    scope.row.containerType,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "containerType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.containerType",
                                                },
                                              },
                                              _vm._l(
                                                _vm.containerTypeList,
                                                function (item, index) {
                                                  return _c("el-option", {
                                                    key: index,
                                                    attrs: {
                                                      label: String(item),
                                                      value: item,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "span",
                                    { staticClass: "required-marker" },
                                    [_vm._v(" *")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "required-marker" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("home.containerType"))
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "shipperVgmPersonSig",
                                width: "140",
                                label: _vm.$t("home.vgmPeople"),
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              "formVgm." +
                                              scope.$index +
                                              ".shipperVgmPersonSig",
                                            rules:
                                              _vm.rules.shipperVgmPersonSig,
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            directives: [
                                              {
                                                name: "uppercase",
                                                rawName: "v-uppercase",
                                              },
                                            ],
                                            attrs: {
                                              disabled: _vm.preLockFlag,
                                              maxlength: "50",
                                              onblur:
                                                "this.value = this.value.toUpperCase()",
                                            },
                                            model: {
                                              value:
                                                scope.row.shipperVgmPersonSig,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "shipperVgmPersonSig",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.shipperVgmPersonSig",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              {
                                attrs: {
                                  prop: "vgmMethod",
                                  width: "120",
                                  label: _vm.$t("home.vgmMethod"),
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "formVgm." +
                                                scope.$index +
                                                ".vgmMethod",
                                              rules: _vm.rules.vgmMethod,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  clearable: "",
                                                  disabled: _vm.preLockFlag,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.handleChangeVgmMethod(
                                                      scope.row.vgmMethod,
                                                      scope.row,
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: scope.row.vgmMethod,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "vgmMethod",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.vgmMethod",
                                                },
                                              },
                                              _vm._l(
                                                _vm.locationList,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.codeValue,
                                                    attrs: {
                                                      label:
                                                        _vm.language === "zh"
                                                          ? item.displayValueCn
                                                          : item.displayValue,
                                                      value: Number(
                                                        item.codeValue
                                                      ),
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "span",
                                    { staticClass: "required-marker" },
                                    [_vm._v(" *")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "required-marker" },
                                    [_vm._v(_vm._s(_vm.$t("home.vgmMethod")))]
                                  ),
                                ]),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              {
                                attrs: { prop: "vgmGrossWeight", width: "140" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "formVgm." +
                                                scope.$index +
                                                ".vgmGrossWeight",
                                              rules: _vm.rules.vgmGrossWeight,
                                            },
                                          },
                                          [
                                            _c("el-input-number", {
                                              attrs: {
                                                disabled: _vm.preLockFlag,
                                                precision: 3,
                                                "auto-cut": true,
                                                controls: false,
                                                max: 9999999.999,
                                              },
                                              model: {
                                                value: scope.row.vgmGrossWeight,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "vgmGrossWeight",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.vgmGrossWeight",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "span",
                                    { staticClass: "required-marker" },
                                    [_vm._v(" *")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "required-marker" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("home.vgmGrossWeight"))
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              {
                                attrs: {
                                  prop: "vgmScale",
                                  label: _vm.$t("home.vgmScale"),
                                  width: "140",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "formVgm." +
                                                scope.$index +
                                                ".vgmScale",
                                              rules: _vm.rules.vgmScale,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  clearable: "",
                                                  disabled: _vm.preLockFlag,
                                                },
                                                model: {
                                                  value: scope.row.vgmScale,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "vgmScale",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.vgmScale",
                                                },
                                              },
                                              _vm._l(
                                                _vm.vgmScaleList,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.codeValue,
                                                    attrs: {
                                                      label:
                                                        _vm.language === "zh"
                                                          ? item.displayValueCn
                                                          : item.displayValue,
                                                      value: Number(
                                                        item.codeValue
                                                      ),
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "span",
                                    { staticClass: "required-marker" },
                                    [_vm._v(" *")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "required-marker" },
                                    [_vm._v(_vm._s(_vm.$t("home.vgmScale")))]
                                  ),
                                ]),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "vgmDate",
                                label: _vm.$t("home.vgmDate"),
                                width: "130",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-form-item",
                                        { attrs: { prop: "vgmDate" } },
                                        [
                                          _c("el-date-picker", {
                                            attrs: {
                                              disabled: _vm.preLockFlag,
                                              "value-format":
                                                "yyyy-MM-dd HH:mm:ss",
                                              format: "yyyy-MM-dd HH:mm",
                                              type: "datetime",
                                            },
                                            model: {
                                              value: scope.row.vgmDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "vgmDate",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.vgmDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "location",
                                width: "140",
                                label: _vm.$t("home.location"),
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-form-item",
                                        { attrs: { prop: "location" } },
                                        [
                                          _c("el-input", {
                                            directives: [
                                              {
                                                name: "uppercase",
                                                rawName: "v-uppercase",
                                              },
                                            ],
                                            attrs: {
                                              disabled: _vm.preLockFlag,
                                              maxlength: "50",
                                              onblur:
                                                "this.value = this.value.toUpperCase()",
                                            },
                                            model: {
                                              value: scope.row.location,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "location",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.location",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "remark",
                                label: _vm.$t("home.remark"),
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-form-item",
                                        { attrs: { prop: "location" } },
                                        [
                                          _c("el-input", {
                                            directives: [
                                              {
                                                name: "uppercase",
                                                rawName: "v-uppercase",
                                              },
                                            ],
                                            attrs: {
                                              disabled: _vm.preLockFlag,
                                              maxlength: "50",
                                              onblur:
                                                "this.value = this.value.toUpperCase()",
                                            },
                                            model: {
                                              value: scope.row.remark,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "remark",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.remark",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "shipperOther",
                                label: _vm.$t("home.other"),
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-form-item",
                                        { attrs: { prop: "shipperOther" } },
                                        [
                                          _c("el-input", {
                                            directives: [
                                              {
                                                name: "uppercase",
                                                rawName: "v-uppercase",
                                              },
                                            ],
                                            attrs: {
                                              disabled: _vm.preLockFlag,
                                              maxlength: "50",
                                              onblur:
                                                "this.value = this.value.toUpperCase()",
                                            },
                                            model: {
                                              value: scope.row.shipperOther,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "shipperOther",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.shipperOther",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { width: "40px" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            disabled:
                                              _vm.preLockFlag || _vm.isDisable,
                                            type: "text",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleRemoveCharge(
                                                scope.row,
                                                scope.$index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-remove-outline",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              icon: "el-icon-folder-checked",
                              disabled: _vm.preLockFlag || _vm.isDisable,
                            },
                            on: { click: _vm.handleAddChargeTobu },
                          },
                          [_vm._v(_vm._s(_vm.$t("home.vgmTobu")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              icon: "el-icon-plus",
                              disabled: _vm.preLockFlag || _vm.isDisable,
                            },
                            on: { click: _vm.handleAddCharge },
                          },
                          [_vm._v(_vm._s(_vm.$t("home.vgmTitle")))]
                        ),
                        _vm._v(" "),
                        _vm.formMain.pol === "CNYNT"
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  color: "red",
                                  "font-size": "12px",
                                  "line-height": "18px",
                                },
                              },
                              [
                                _vm.language === "zh"
                                  ? _c("div", [
                                      _vm._v(
                                        "托运人裁货集装箱重量验证声明如下:"
                                      ),
                                    ])
                                  : _c("div", [
                                      _vm._v(
                                        "Shipper's container weight verification statement is as follows:"
                                      ),
                                    ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n                      使用整体称重法的(SM1)，声明内容为:“本托运人声明:该文件资料所含载货集装箱重量信息系按照《1974年国际海上人命安全公约》第VI/2.4.1条所述方法获得，称重点的衡器已取得计量技术机构颁发的计量检定证书，且获得重量的日期在证书的有效期范围内。”"
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n                      使用累加计算法的(SM2)，声明内容为:“本托运人声明:该文件资料所含载货集装箱重量信息系按照《1974年国际海上人命安全公约》第VI/2.4.2条所述方法获得，该方法符合主管机关制定并公布的《载货集装箱累加计算法重量验证指南》的要求。”\n              "
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.formMain.pol === "CNYNT"
                          ? [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-top": "16px",
                                    color: "#3fb2eb",
                                    "font-size": "12px",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleOpenOne(
                                        "/static/doc/VGMONE.doc"
                                      )
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("home.titleOne")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-top": "10px",
                                    color: "#3fb2eb",
                                    "font-size": "12px",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleOpenOne(
                                        "/static/doc/VGMTWO.doc"
                                      )
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("home.titleTwo")))]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "right",
                          margin: "20px 0 0px 0",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-bottom": "20px" },
                            attrs: {
                              type: "plain",
                              plain: "",
                              disabled: _vm.preLockFlag || _vm.isDisable,
                            },
                            on: { click: _vm.handleSubimtSign },
                          },
                          [_vm._v(_vm._s(_vm.$t("home.cancelButton")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-bottom": "20px" },
                            attrs: {
                              type: "primary",
                              plain: "",
                              disabled: _vm.preLockFlag || _vm.isDisable,
                            },
                            on: { click: _vm.handleSubimt },
                          },
                          [_vm._v(_vm._s(_vm.$t("home.sureButton")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }